import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { getStudyFromStudies, filterStudyList } from '../../util/CommonUtils';

import {
  PREFERENCE_CROSSTAB,
  PREFERENCE_QUICKREPORTS,
  PREFERENCE_DATAHAUL,
  PREFERENCE_STORIES,
  PREFERENCE_BRAND_CATALYST,
  PREFERENCE_SALES_CATALYST,
  CROSSTAB_FEATUREID,
  QUICKREPORTS_FEATUREID,
  DATAHAUL_FEATUREID,
  STORIES_FEATUREID,
  BRAND_CATALYST_FEATUREID,
  SALES_CATALYST_FEATUREID,
} from '../../constants';

class PreferencesCustomRadioButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      weightType: props.field.defaultValue,
      hideWeightType: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.studies) {
      let selectedStudy;
      const keys = this.props.field.dbKey.split('.');
      let feature;
      if (keys[0] === PREFERENCE_CROSSTAB) {
        feature = CROSSTAB_FEATUREID;
      } else if (keys[0] === PREFERENCE_QUICKREPORTS) {
        feature = QUICKREPORTS_FEATUREID;
      } else if (keys[0] === PREFERENCE_DATAHAUL) {
        feature = DATAHAUL_FEATUREID;
      } else if (keys[0] === PREFERENCE_STORIES) {
        feature = STORIES_FEATUREID;
      } else if (keys[0] === PREFERENCE_BRAND_CATALYST) {
        feature = BRAND_CATALYST_FEATUREID;
      } else if (keys[0] === PREFERENCE_SALES_CATALYST) {
        feature = SALES_CATALYST_FEATUREID;
      }
      const studyList = filterStudyList(nextProps.studies, feature);
      if (!_.isEmpty(nextProps.modifiedPreferences) && nextProps.modifiedPreferences[keys[0]]._ds !== -1) {
        selectedStudy = getStudyFromStudies(studyList, nextProps.modifiedPreferences[keys[0]]._ds);
      } else {
        selectedStudy = studyList[0].sl[0];
      }
      if (selectedStudy.wt > 2) {
        this.setState(() => ({ hideWeightType: true }));
      } else {
        this.setState(() => ({ hideWeightType: false }));
      }
    }
    if (!_.isEmpty(nextProps.userPreference) &&
    nextProps.userPreference !== this.props.userPreference) {
      const keys = this.props.field.dbKey.split('.');
      this.setState(() => ({ weightType: nextProps.userPreference[keys[0]][keys[1]] }));
    }
  }

  handleChangeWeightType = weightType => {
    this.setState(() => ({ weightType }));
    this.props.updatePreferences(this.props.field.dbKey, weightType);
  }

  render() {
    const { values, style } = this.props.field;
    const { hideWeightType } = this.state;
    return (
      <div>
        {!hideWeightType && <div
          className="preferences-radio-container"
          style={{ marginLeft: style && style.marginLeft }}
        >
          {values.map((element, index) => (
            <div
              key={element + index}
              className="preferences-radio-container-menu"
            >
              <input
                type="radio"
                name="weighting"
                id={element.label}
                checked={this.state.weightType === element.label}
                className="preferences-radio-container-menu-radio"
                onClick={() => this.handleChangeWeightType(element.label)}
              />
              <label
                htmlFor={element.label}
                className="preferences-radio-container-menu-label"
              >{element.label}</label>
              {(values.length - 1) !== index &&
                <span className="preferences-radio-container-menu-seperator">/</span>}
            </div>
          ))
          }
        </div>}
      </div>
    );
  }
}

PreferencesCustomRadioButtons.propTypes = {
  field: PropTypes.shape({
    dbKey: PropTypes.string,
    style: PropTypes.shape({}),
    values: PropTypes.arrayOf(PropTypes.shape({})),
    defaultValue: PropTypes.string,
  }),
  updatePreferences: PropTypes.func,
  userPreference: PropTypes.shape({}),
};

function mapStateToProps(state) {
  return {
    userPreference: state.preferences.userPreferences,
    studies: state.study.studies,
  };
}

export default connect(mapStateToProps)(PreferencesCustomRadioButtons);
